import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { rbacAdminGuard } from './core/auth/rbac.guard';

export const routes: Routes = [
  {
    path: 'marques',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/marques/marques.routes').then((m) => m.MARQUES_ROUTES),
  },
  {
    path: 'traites',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/traites/traites.routes').then((m) => m.TRAITES_ROUTES),
  },
  {
    path: 'configuration',
    canActivate: [authGuard, rbacAdminGuard],
    loadChildren: () =>
      import('./modules/configuration/configuration.routes').then(
        (m) => m.CONFIGURATION_ROUTES
      ),
  },
  {
    path: 'audit',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/audit/audit.routes').then((m) => m.AUDIT_ROUTES),
  },
  { path: '', redirectTo: 'marques', pathMatch: 'full' },
];
